const cleanString = (x) => x.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s/g, '')
  .toLowerCase();

export default cleanString;
